import React, { useState } from 'react';
import { sizes } from '../Data';
import './styles.scss';



const SizeSlider = ({ switchSize, currentSize }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const [selectedSize, setSelectedSize] = useState(0)

    const nextSlide = () => {
        if (currentIndex < sizes.length - 3) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const prevSlide = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    return (
    <div className='size-main'>
        <div className='size-heading'>Select Size</div>
        <div className="size-slider">
            <button className="nav-button prev" onClick={prevSlide} disabled={currentIndex === 0}><img src='icons/slider-button.png' /></button>
            <div className="size-slider-container">
                <div className="size-slider-track" style={{ transform: `translateX(-${currentIndex * 33.3}%)` }}>
                    {sizes.map((size, index) => (
                        <div key={index} className={`size-slide ${sizes.indexOf(currentSize) == index && 'active'}`} onClick={() => { switchSize(size); setSelectedSize(index) }}>
                            <img src={size.image} alt={size.name} className="size-image" />
                            <h3 className="size-name">{size.name}</h3>
                        </div>
                    ))}
                </div>
            </div>
            <button className="nav-button next" onClick={nextSlide} disabled={currentIndex >= sizes.length - 3}><img src='icons/slider-button.png' /></button>
        </div>
    </div>
    );
};

export default SizeSlider;
